import { CheckIcon, ClipboardDocumentIcon } from "@heroicons/react/24/outline";
import { useCallback, useState } from "react";

export const CopyButton: React.FC<{ value: string; title?: string }> = ({
    value,
    title = "Copy to clipboard",
}) => {
    const [copied, setCopied] = useState(false);
    const copy = useCallback(() => {
        navigator.clipboard.writeText(value).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    }, [value]);
    return (
        <button
            type="button"
            className="ml-2 p-1 rounded hover:bg-slate-700 hover:text-white"
            onClick={copy}
            title={title}
            aria-label={title}
        >
            {copied ? (
                <CheckIcon className="w-4 h-4 text-green-400" />
            ) : (
                <ClipboardDocumentIcon className="w-4 h-4" />
            )}
        </button>
    );
};
